import React from "react";

/**
 * App-level error boundary. Catches runtime errors thrown while rendering any
 * route so a single broken screen shows a recoverable message instead of a
 * blank white page (which is what happened when a chart controller was
 * unregistered on the fee-management screen).
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Surface the error so it is not silently swallowed in production.
    console.error("Uncaught render error:", error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          role="alert"
          style={{
            minHeight: "100vh",
            display: "grid",
            placeItems: "center",
            background: "#f8fafc",
            color: "#27697b",
            font: "600 15px system-ui, sans-serif",
            padding: "24px",
            textAlign: "center",
          }}
        >
          <div style={{ maxWidth: 480 }}>
            <div style={{ fontSize: 20, marginBottom: 12 }}>
              Something went wrong on this screen.
            </div>
            <div style={{ fontWeight: 400, marginBottom: 20, color: "#5b6b70" }}>
              The page hit an unexpected error. You can try again or reload.
            </div>
            <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
              <button
                type="button"
                onClick={this.handleReset}
                style={{
                  padding: "10px 18px",
                  borderRadius: 8,
                  border: "1px solid #27697b",
                  background: "#27697b",
                  color: "#fff",
                  cursor: "pointer",
                  font: "600 14px system-ui, sans-serif",
                }}
              >
                Try again
              </button>
              <button
                type="button"
                onClick={() => window.location.reload()}
                style={{
                  padding: "10px 18px",
                  borderRadius: 8,
                  border: "1px solid #cbd5e1",
                  background: "#fff",
                  color: "#27697b",
                  cursor: "pointer",
                  font: "600 14px system-ui, sans-serif",
                }}
              >
                Reload page
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
